import { StatCombo } from '@/components/common/Stat'
import { usePage } from '@/components/providers/PageProvider'
import { type StatComboType } from '@/defs/stat'
import { useCardMap } from '@/hooks/useCardMap'
import { getColorId } from '@/utils/cardUtil'

import { FeaturedCommonStats } from '../../FeaturedCommon/FeaturedCommonStats/FeaturedCommonStats'

type Props = {
  stats: StatComboType[]
}

export const FeaturedComboStats = ({ stats }: Props) => {
  const { page } = usePage()
  const combo = page?.featuredCombo
  const cardIds = combo?.cards.map(({ cardId }) => cardId)
  const { cardMap } = useCardMap({ cardIds })

  if (!combo) return null

  const comboPreview = {
    ...combo,
    colorId: getColorId(combo.cards.map(({ cardId }) => cardMap[cardId]?.colorId || 'colorless')),
    nonCardPrerequisiteCount: combo.prerequisites.length,
  }

  return (
    <FeaturedCommonStats
      statElements={stats.map((stat) => (
        <StatCombo combo={comboPreview} key={stat} stat={stat} />
      ))}
    />
  )
}
